import { useEffect, useMemo, useState } from "react";
import axios from "util/Api";
import API_ENDPOINTS from "util/apiEndpoints";

const LIVE_ACCESS_META = {
  panel: null,
  isLocked: false,
  isPreview: false,
  message: "",
};

const createAccessMeta = (panel) => ({
  ...LIVE_ACCESS_META,
  panel: panel || null,
});

export const inferPanelKeyFromMockupSrc = (src = "") => {
  const normalized = String(src || "").toLowerCase();
  if (!normalized) return "";
  const fileName = normalized.split("/").pop() || "";
  return fileName.replace(/mockup\.html?$/, "").replace(/mockup$/, "");
};

export const useEmployeePanelAccess = ({ panelKey, employeeKey, fallbackPanel } = {}) => {
  const [assignments, setAssignments] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    axios
      .get(API_ENDPOINTS.personas.employeeRegistry)
      .then((response) => {
        if (!active) return;
        const payload = (response && response.data && response.data.data) || {};
        setAssignments(Array.isArray(payload.assignments) ? payload.assignments : []);
        setLoaded(true);
      })
      .catch(() => {
        if (!active) return;
        setAssignments([]);
        setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  return useMemo(() => {
    const matchedPanel = fallbackPanel
      || assignments.find((row) => (panelKey && row.panel_key === panelKey) || (employeeKey && row.employee_key === employeeKey))
      || null;

    return {
      ...createAccessMeta(matchedPanel),
      loaded,
    };
  }, [assignments, employeeKey, fallbackPanel, loaded, panelKey]);
};

export const notifyEmployeePreviewLocked = () => {};

export const withEmployeePreviewGuard = (_accessMeta, action) => action();

export const getEmployeePreviewMeta = createAccessMeta;
